//export const API_BASE_URL = 'https://bods.javelin-cms.co.uk/api';
export const API_BASE_URL = '/api';

